<template>
   <div class="row team-blocks">
      <div class="col-12 top-bordered">
         <div :class="['card-deck', 'card-deck-special']">
            <div v-for="(member, index) in sortedTeam" v-if="member" :key="index" class="card">
               <div
                  class="card-content  card-bordered"
                  itemscope
                  itemtype="http://schema.org/Person"
               >
                  <div class="card-header text-center ">
                     <img
                        :class="['img rounded-circle']"
                        :src="member.pic"
                        alt="member.name"
                        itemprop="image"
                     />
                  </div>
                  <div class="card-body">
                     <h3 class="text-center h4 bold" itemprop="name" v-text="member.name" />
                     <div
                        v-if="member.designation"
                        class="text-center designation"
                        itemprop="jobTitle"
                        v-text="member.designation"
                     />
                     <div class="desc" v-html="markedRender(member.desc)" />
                  </div>
                  <div v-if="member.extrainfo" class="card-footer">
                     <div class="social-label">Follow {{ member.name }} on</div>
                     <div class="social-links">
                        <span v-for="(social, indexA) in member.extrainfo" :key="indexA">
                           <a title="" target="_blank" rel="noopener noreferrer" :href="social.link" itemprop="url">
                              <i :class="social.icon" />
                           </a>
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
export default {
   name: 'TeamList',

   props: {
      deptmembers: {
         type: Array,
         default: () => [],
      },
   },

   computed: {
      sortedTeam() {
         let team = [];
         team = this.allTeams;
         // team.sort((a, b) => new Date(a.doj) - new Date(b.doj));
         // return team;
         team.sort((a, b) => {
            if (new Date(a.doj) > new Date(b.doj)) return 1;
            if (new Date(a.doj) < new Date(b.doj)) return -1;
            if (a.name > b.name) return 1;
            return -1;
         });

         return team;
      },

      allTeams() {
         const option = [];
         for (let i = 0, l = this.deptmembers.length; i < l; i++) {
            const team = this.deptmembers[i];
            team.members.forEach(item => {
               option.push({
                  name: item.memberName,
                  designation: item.memberPosition,
                  desc: item.memberDesc,
                  pic: item.memberImg,
                  extrainfo: item.memberExtra.social,
                  dept: item.memberDept,
                  doj: item.memberExtra.doj,
               });
            });
         }
         return option;
      },
   },
};
</script>
<style lang="scss" scoped>
.base-dropdown {
   width: 200px;
}
img {
   &.rounded-circle {
      max-width: 100px;
   }
}
.top-bordered {
   border-top: 1px solid rgba(62, 57, 107, 0.04);
   padding-top: 1rem;
}
.card-deck {
   .card {
      background: none !important;
      border-radius: 0;
      margin: 0;
      flex: 0 0 auto;
      min-width: 100%;
      max-width: 100%;
      .card-content {
         margin: 1.5rem;
         border: 1px solid rgba(62, 57, 107, 0.04);
         border-radius: 4px;
         background-color: rgba(255, 255, 255, 0.9);
         box-shadow: none;
         height: 100%;
         display: flex;
         flex-direction: column;
         .desc {
            margin-top: 2rem;
         }
      }

      @media (min-width: 567px) {
         flex: 0 0 auto;
         min-width: 50%;
         max-width: 50%;
      }

      @media (min-width: 992px) {
         flex: 0 0 auto;
         min-width: 33.33%;
         max-width: 33.33%;
      }
   }
}

.card {
   .h4 {
      font-size: 19px;
   }
   .designation {
      font-size: 14px;
      line-height: 1.2;
      color: #434456;
   }
   .card-header {
      padding: 3.5rem 3.5rem 1.5rem;
   }

   .card-body {
      padding: 0 3.5rem;
      font-size: 14px;
      line-height: 1.5;
   }

   .card-footer {
      padding: 0 3.5rem 3.5rem;
      color: #8786a4;
      .social-label,
      .social-links {
         display: inline-block;
         vertical-align: middle;
      }

      .social-label {
         margin-right: 5px;
      }

      .social-links {
         min-width: 130px;
      }
      span {
         display: inline-block;
         vertical-align: middle;
         margin: 0 3px;
         a {
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #cecece;
            background: #fff;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
            &:hover {
               color: #ccc;
               opacity: 0.8;
               box-shadow: 0 1px 2px 0 rgba(62, 57, 107, 0.13);
            }

            i {
               font-size: 20px;
            }
         }
      }
   }
}
</style>
